import { useEffect, useState } from "react";

import styles from "./Dropdown.module.scss";

import dropdownArrow from "./assets/img/icon-arrow-down.svg";
import checkMark from "../../assets/img/icon-check-white.svg";
import useClickOutside from "../../hooks/useClickOutside";

type Props = {
  placeholderText: string;
  defaultValue?: {
    value: string;
    label: string;
  };
  options: {
    value: string;
    label: string;
  }[];
  onSelect: Function;
  className?: string;
  buttonIcon?: string;
};

const Dropdown = ({
  placeholderText,
  options,
  onSelect,
  className = "",
  defaultValue,
  buttonIcon = dropdownArrow,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    defaultValue || {
      label: placeholderText,
      value: "",
    }
  );
  const nodeRef = useClickOutside(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    setSelectedOption(
      defaultValue || {
        label: placeholderText,
        value: "",
      }
    );
  }, [defaultValue, placeholderText]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: { value: string; label: string }) => {
    setSelectedOption(option);
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div className={`${styles.dropdown} ${className}`} ref={nodeRef}>
      <div
        className={`${styles.dropdown__button} ${isOpen ? styles.open : ""}`}
        onClick={toggleDropdown}
      >
        <p>{selectedOption.label}</p>
        <img src={buttonIcon} alt="dropdown arrow" />
      </div>
      {isOpen && (
        <ul className={styles.dropdown__options}>
          <div className={styles.dropdown__wrapper}>
            {options.map((option) => (
              <li
                key={option.value}
                className={option.value === selectedOption.value ? styles.selectedOption : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
                {option.value === selectedOption.value && <img src={checkMark} />}
              </li>
            ))}
          </div>
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
